requirejs.config({
    baseUrl: '/organizer/scripts/',
    paths: {
        'bizzabo/config': 'bizzabo/config.js?v=abfaec1db6425aeaf4926718ba4fa27b',
        'promise-polyfill': 'promise-polyfill/polyfill',
        'axios': 'axios/axios',
        'jquery': 'jquery/jquery-2.0.3.min',
        'jquery-ui': 'jquery/ui/jquery-ui-1.10.3.custom.min',
        'underscore': 'libs/shim-underscore',
        'backbone': 'libs/shim-backbone.1.0.0',
        'backbone-easyxdm': 'libs/backbone-easyxdm',
        'Handlebars': 'libs/shim-handlebars',
        'easyXDM': 'libs/shim-easyXDM.min',
        'text': 'libs/text.2.0.5',
        'jquery-cookie': 'libs/jquery.cookie',
        'jquery-chosen': 'jquery/chosen/chosen.jquery.min',
        'jquery-charcount': 'jquery/jquery.charCount',
        'jquery-placeholder': 'jquery/jquery.placeholder.min',
        'jquery-timepicker': 'jquery/timepicker/jquery.timepicker.min',
        'jquery-colorpicker': 'jquery/simplecolorpicker/jquery.simplecolorpicker',
        'hbars': 'libs/hbars',
        'backbone-validation-original': 'libs/backbone-validation-amd-min',
        'backbone-validation': 'backbone/backbone.bizzabo.validation',
        'backbone-queryparams': 'backbone/backbone.queryparams',
        'GSModel': 'backbone/backbone.getters.setters',
        'timezoneJS': 'libs/shim-timezone',
        'ZeroClipboard': 'ZeroClipboard/ZeroClipboard',
        'jquery-zclip' : 'libs/jquery.zclip.min',
        'fuse': 'fuse/fuse',
        'Highcharts': 'highcharts/highcharts',
        'socket-io': 'libs/socket.io.min',
        'spin': 'libs/ladda/spin',
        'laddaOriginal': 'libs/ladda/ladda',
        'ladda': 'libs/ladda/laddaWrapper',
    },
    shim: {
        'jquery-cookie': ['jquery'],
        'jquery-chosen': ['jquery'],
        'jquery-ui': ['jquery'],
        'jquery-charcount': ['jquery'],
        'jquery-placeholder': ['jquery'],
        'jquery-timepicker': ['jquery'],
        'jquery-colorpicker': ['jquery'],
        'axios': ['promise-polyfill'],
        'socket-io': {
            exports: 'io'
        }
    },
    hbars: {
        extension: '.handlebars'
    }
});

define("main", function(){});

